<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params" :rules="rules">
        <el-col :span="3" :xs="12">
          <el-form-item prop="ids">
            <el-input
              v-model="params.ids"
              maxlength="6"
              placeholder="输入设备编号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="deviceId">
            <el-input
              v-model="params.deviceId"
              maxlength="6"
              placeholder="输入设备ID"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-form-item prop="socketNum">
            <el-input v-model.number="params.socketNum" placeholder="插座号" />
          </el-form-item>
        </el-col>
        <el-col :span="7" :xs="24">
          <!-- <el-date-picker
              v-model="time"
              :clearable="false"
              :picker-options="pickerOptions"
              end-placeholder="结束日期"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              value-format="timestamp"/> -->
          <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          />
        </el-col>

        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table v-loading="loadTable" :data="records" stripe>
      <el-table-column label="ID" prop="id" sortable="custom" />
      <!--      <el-table-column label="用户手机号" prop="phone"/>-->
      <el-table-column label="电站编号" prop="chargingPileIds" min-width="130">
        <template #default="scope">
          {{ scope.row.deviceId }}( {{ scope.row.chargingPileIds }})
        </template>
      </el-table-column>
      <el-table-column label="插座" prop="socketNum" />
      <el-table-column label="时间" width="150px">
        <template #default="scope">
          {{
            scope.row.startTime === 0
              ? "未开始"
              : timeFormat(scope.row.startTime)
          }}<br />
          <template v-if="scope.row.endTime === 0"> 充电中 </template>
          <template v-else>
            {{ timeFormat(scope.row.endTime) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column label="充电时长">
        <template #default="scope">
          {{
            scope.row.startTime === 0
              ? "未开始"
              : differTime(scope.row.startTime, scope.row.endTime) + "分钟"
          }}
        </template>
      </el-table-column>
      <el-table-column :formatter="formatterSum" label="金额" prop="money" />
      <el-table-column :formatter="formatterSum" label="豆币" prop="token" />
      <el-table-column label="度数">
        <template #default="scope">
          {{
            new BigNumber(scope.row.powerConsumption).plus(
              new BigNumber(scope.row.powerConsumptionStop || 0)
            )
          }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status">
        <template #default="scope">
          <template v-if="scope.row.state === '1'"> 等待连接 </template>
          <template v-else-if="scope.row.state === '2'"> 充电中 </template>
          <template v-else-if="scope.row.state === '3'"> 暂停 </template>
          <template v-else-if="scope.row.state === '4'"> 完成 </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template #default="scope">
          <el-button size="mini" @click="detail(scope.row.id)">详细</el-button>
          <el-button
            v-if="scope.row.state === '2' || !isBefore60Days(scope.row.endTime)"
            size="mini"
            @click="wave(scope.row.id)"
            >功率图</el-button
          >
          <el-button
            v-if="
              scope.row.state === '1' ||
              scope.row.state === '2' ||
              scope.row.state === '3'
            "
            size="mini"
            type="danger"
            @click="finish(scope.row.id)"
          >
            结束
          </el-button>
          <el-button
            v-if="scope.row.state === '4' && scope.row.isRefund === '0'"
            size="mini"
            type="success"
            @click="refundOrder(scope.row.id)"
            >退单
          </el-button>
          <el-button
            v-if="scope.row.state === '4' && scope.row.isRefund === '1'"
            disabled
            size="mini"
            type="info"
            >退单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <refund-order-dialog :id="id" :dialog="refundOrderDialog" />
    <order-details-dialog :id="id" :dialog="orderDetailsDialog" />
    <finish-order-dialog :id="id" :dialog="finishOrderDialog" />
    <refund-order-dialog :id="id" :dialog="refundOrderDialog" />
    <wave-dialog :id="id" :dialog="waveDialog" />
  </div>
</template>

<script>
import agentGetOrderListByWhere from "@/api/fund/order-manage/agentGetOrderListByWhere";
import FinishOrderDialog from "@/components/Dialog/finishOrderDialog";
import OrderDetailsDialog from "@/components/Dialog/orderDetailsDialog";
import RefundOrderDialog from "@/components/Dialog/refundOrderDialog";
import WaveDialog from "@/components/Dialog/waveDialog";
import Page from "@/components/Page";
import createdMixin from "@/mixin/createMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
// import SearchByMemberAndCard2 from "@/components/SearchByMemberAndCard2";
import formatterSumMixin from "@/mixin/formatterMixin";
import BigNumber from "bignumber.js";

export default {
  name: "ElectricityCardDetailOne",
  components: {
    RefundOrderDialog,
    WaveDialog,
    FinishOrderDialog,
    OrderDetailsDialog,
    Page,
  },
  mixins: [createdMixin, pageMixin, timeMixin, searchMixin, formatterSumMixin],
  data() {
    return {
      BigNumber,
      waveDialog: false,
      id: undefined,
      finishOrderDialog: false,
      orderDetailsDialog: false,
      refundOrderDialog: false,
      rules: {
        socketNum: [{ type: "number", message: "插座号必须为数字值" }],
      },
      time: "",
      records: [],
      params: {
        memberType: 3,
        memberId: this.$route.query.id,
        socketNum: undefined,
        sortName: "id",
        sortType: "DESC",
      },
    };
  },
  methods: {
    refundOrder(id) {
      this.id = id;
      this.refundOrderDialog = true;
    },
    wave(id) {
      this.id = id;
      this.waveDialog = true;
    },
    detail(id) {
      this.id = id;
      this.orderDetailsDialog = true;
    },
    finish(id) {
      this.id = id;
      this.finishOrderDialog = true;
    },
    fetchData() {
      agentGetOrderListByWhere(this.params, this.current, this.size).then(
        (res) => {
          this.total = res.total;
          this.records = res.records;
        }
      );
    },
  },
};
</script>
